module.exports = __webpack_public_path__ + "static/05-c3a524694cb3ce764c477a469a575350.png";